import { z } from "zod";

export const consentReminderPopupSchema = z.object({
  enabled: z.boolean(),
  mainImage: z.string().url().optional(),
  imageAltText: z.string().optional(),
  subtitle: z.string().optional(),
  mainQuestion: z.string().optional(),
  description: z.string().optional(),
  yesButtonText: z.string().optional(),
  noButtonText: z.string().optional(),
  yesRedirectUrl: z.string().url().optional(),
  maximumOccurancesPerYear: z.number().int().optional(),
  consentExpirationLimit: z.number().int().optional(),
  popUpDelay: z.number().int().optional(),
  offerConsentName: z.string().optional(),
  productInformationConsentName: z.string().optional(),
  ploomClubConsentName: z.string().optional(),
});
